var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('line-chart',{staticClass:"chart"}),(_vm.period === 'month')?_c('div',{staticClass:"xAxisMonth"},[_vm._v(_vm._s(_vm.currentMonth))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }